module.exports = "<div class=\"registration tile\" ngClass=\"{{registration?.state?.toString()}}\"> <span> <p class=\"label\">{{registration?.labelToDisplay}}</p> <p class=\"comment\" *ngIf=\"registration?.hourValid\">{{registration.datePlanned | date : \"HH:mm\"}}</p> </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/faculty-queues/registration-tile/registration-tile.component.html
// module id = 311
// module chunks = 0